import { SectionWrapper } from 'src/components/Layouts';
import css from './css.module.less';
import React from 'react';
import {
  //IOrderPackItem,
  EType,
} from 'src/types/common/order';
import { SizeFittingTable, Image } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { EnumTablePosition } from 'src/types/common/common';
import { get } from 'lodash';
//import { ChangeSize } from 'src/tools/customHooks';
import { EExternalRef } from '../tools';
import { accMul } from 'src/tools/math';
import CustomizationRow from 'src/pages/Order/Components/ExclusiveCustom';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
// export const mockData: IOrderPackItem[] = [
//   {
//     uuid: '1',
//     orderLineItemUuid: '1',
//     salesChannelProductUuid: '1',
//     productUuid: '1',
//     type: EType.Buy,
//     image: { uuid: '1', url: '' },
//     productName: '1',
//     productSetName: '1',
//     sku: '1',
//     productSetSku: '!',
//     amount: 3,
//     totalPrice: 2,
//     discountPrice: 1,
//     paidPrice: 123,
//     customisation: {},
//   },
// ];

const ReadyToPick = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { data } = props;

  const amount = (data || []).reduce((pre, now) => {
    const { amount } = now;
    return pre + amount;
  }, 0);

  // const currentKeys = React.useMemo(() => {
  //   return data.map((i) => i.uuid);
  // }, [data]);
  // React.useEffect(() => {
  //   setSelectedKeys()
  // }, [currentKeys]);
  // console.log('123');

  const expandedRows = (data || []).map((i) => i.uuid);

  const tableName = 'OrderDetailReadyToPickTable';
  return (
    <SectionWrapper
      title={`${getI18n(
        'allOrders.orderDetail.outofstock_readytopick_return_section_title',
      )}(${amount} items)`}
      containerClassName={css.wrapper}>
      <div className={css.container}>
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          dataSource={data}
          className={css.readyToPickTable}
          id={tableName}
          columns={col({ getI18n })}
          expandable={{
            expandedRowClassName: (record) => {
              const isParent = get(record, EExternalRef.isParent);
              const isChild = get(record, EExternalRef.isChild);
              const isLast = get(record, EExternalRef.isLast);
              //console.log(record);
              const shouldHideBottomLine = (isParent || isChild) && !isLast;
              return `${css.expandedRow} ${
                shouldHideBottomLine ? css.hideBottomLine : ''
              }`;
            },
            expandedRowKeys: expandedRows,
            expandIconColumnIndex: -1,
            indentSize: 0,
            expandedRowRender: (record, index) => {
              //const isParent = get(record, EExternalRef.isParent);
              const isChild = get(record, EExternalRef.isChild);
              const customisationItem =
                get(record, 'customisation.items') || [];

              if (isChild) {
                return <React.Fragment />;
              }
              if (!customisationItem.length) {
                return <React.Fragment />;
              }
              // return (
              //   <div className={css.customizationLine}>
              //     <CustomizationRow
              //       title={`專屬定制：刻字”XXX”`}
              //       price={'100'}
              //     />
              //   </div>
              // );
              return (
                <React.Fragment>
                  <div className={css.customizationLine}>
                    {customisationItem.map((i, index) => {
                      const { title, values } = i;
                      const content = (values || []).join(',');
                      return (
                        <CustomizationRow
                          key={index}
                          title={`${title}: ${content}`}
                          //price={'100'}
                        />
                      );
                    })}{' '}
                  </div>
                </React.Fragment>
              );
            },
          }}
        />
      </div>
    </SectionWrapper>
  );
};
export default ReadyToPick;
const widthDict = {
  item: { minWidth: 180 },
  sku: { minWidth: 140 },
  qty: {
    width: 110,
  },

  paid: { width: 90 },
};
const col = ({ getI18n }) => {
  return [
    {
      title: getI18n(
        'allOrders.orderDetail.components_packagedetail_colreturn_item_title',
      ),
      key: 'Items (Store)',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { productName } = record;
        const isChild = get(record, EExternalRef.setUuid);

        const thumbnailUrl = get(record, 'image.url');

        return (
          <div
            className={css.productNameContainer}
            style={{ paddingLeft: isChild ? 45 : 0 }}>
            {/* {thumbnailUrl && ( */}
            <Image
              style={{
                marginRight: 12,
                minWidth: 40,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />
            {/* )} */}
            <NoWrapContainer>
              <GlobalTooltip title={productName || '-'}>
                <div className={css.text}>
                  {productName || '-'}
                  {/* {productName}
                  {productName} */}
                </div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: getI18n('general.sKU'),
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={sku || '-'}>{sku}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () => <span>{getI18n('general.qTY')}</span>,
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        // console.log('record', record);
        const { amount } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={amount}>{amount || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['qty'],
    },
    {
      titleGenerate: () => (
        <div>
          <div>{getI18n('general.paidPrice')}.</div>
          <div>
            ({getI18n('general.excl')}. {getI18n('general.tax')})
          </div>
        </div>
      ),
      key: 'Paid',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        // console.log('record', record);
        const isChild = record[EExternalRef.isChild];
        if (isChild) {
          return <React.Fragment />;
        }
        const { paidPrice, type, amount } = record;

        if (type === EType.Gift) {
          return <span>Gift</span>;
        }
        const num = accMul(amount, paidPrice).toFixed(2);

        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip title={num}>{num || '-'}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];
};
